import { Component, OnInit, AfterViewInit, Input, OnChanges, OnDestroy, NgZone, SimpleChanges } from '@angular/core';
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from '@amcharts/amcharts5/themes/Material';

@Component({
  selector: 'app-am-line-chart',
  templateUrl: './am-line-chart.component.html',
  styleUrls: ['./am-line-chart.component.css']
})
export class AmLineChartComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {

  @Input() reportType: 'DAILY' | 'MONTHLY' | 'YEARLY' = 'DAILY';
  @Input() userIC = true;
  @Input() businessIC = true;
  @Input() mapData = [];
  @Input() min:number =  0;
  @Input() max:number =  100;
  totalsChart: am5xy.XYChart;
  dateAxis: am5xy.DateAxis<am5xy.AxisRenderer>;
  // orderCountSeries: am5xy.ColumnSeries;
  userSeries:  am5xy.LineSeries;
  businessSeries:  am5xy.LineSeries;

  constructor( private zone: NgZone ) { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    setTimeout(() => {
      if (this.totalsChart && this.mapData?.length > 0) {
        this.dateAxis.data.setAll(this.mapData);
        if(this.userIC) {
          this.userSeries.data.setAll(this.mapData);
        } else this.userSeries.data.setAll([]);
        if(this.businessIC) {
          this.businessSeries.data.setAll(this.mapData);
        } else this.businessSeries.data.setAll([]);
      } else {
        if(this.userSeries) this.userSeries.data.setAll([]);
        if(this.businessSeries) this.businessSeries.data.setAll([]);
        if(this.dateAxis) this.dateAxis.data.setAll([]);
      }
      if (this.totalsChart && this.reportType) {
        if (this.reportType === 'DAILY') {
          this.dateAxis._settings.baseInterval.timeUnit = 'day';
        } else if (this.reportType === 'MONTHLY') {
          this.dateAxis._settings.baseInterval.timeUnit = 'month';
        } else {
          this.dateAxis._settings.baseInterval.timeUnit = 'year';
        }
      }
    }, 300);
    setTimeout(() => {
      this.totalsChart.zoomOut();
    }, 400);
  }

  ngAfterViewInit() {
    this.zone.runOutsideAngular(() => {
      this.loadTotalsChart();
      this.totalsChart.zoomOut();
    });
  }

  ngOnDestroy() {
    this.zone.runOutsideAngular(() => {
      if (this.totalsChart) {
        this.totalsChart.dispose();
      }
    });
  }

  loadTotalsChart() {
    const root = am5.Root.new("amOrderTotals");
    root.setThemes([am5themes_Animated.new(root)]);
    const chart = root.container.children.push(
      am5xy.XYChart.new(root, {
        panY: false,
        layout: root.verticalLayout
      })
    );
    // Create X-axis
    const dateAxis = chart.xAxes.push(
       am5xy.DateAxis.new(root, {
         baseInterval: { timeUnit: 'day', count: 1 },
         markUnitChange: true,
         renderer: am5xy.AxisRendererX.new(root, {
         }),
       })
     );


    // Create Y-axis
    // const countAxis = chart.yAxes.push(
    //   am5xy.ValueAxis.new(root, {
    //     renderer: am5xy.AxisRendererY.new(root, {})
    //   })
    // );
    // countAxis.children.push(am5.Label.new(root, {
    //   text: "Orders count",
    //   rotation: -90,
    //   y: am5.p50,
    //   centerX: am5.p50
    // }));

    // Create series
    // const orderCountSeries = chart.series.push(
    //   am5xy.ColumnSeries.new(root, {
    //     name: "No of Orders",
    //     xAxis: dateAxis,
    //     yAxis: countAxis,
    //     valueYField: "totalOrderCount",
    //     valueXField: "conversation_start_date",
    //     tooltipText: '{totalOrderCount} Orders'
    //   })
    // );
    // const countToolTip = orderCountSeries.set("tooltip", am5.Tooltip.new(root, {}));
    // countToolTip.label.set("text", "{valueY} Orders");
    // orderCountSeries.columns.template.setAll({
    //   fillOpacity: 0.7,
    // });


    const userAxis = chart.yAxes.push(
      am5xy.ValueAxis.new(root, {
        maxPrecision: 0,
        renderer: am5xy.AxisRendererY.new(root, {
          opposite: false
        }),
        // syncWithAxis: countAxis,
      })
    );
    userAxis.children.push(am5.Label.new(root, {
      rotation: 90,
      y: am5.p50,
      centerX: am5.p50
    }));
    const userSeries = chart.series.push(
      am5xy.LineSeries.new(root, {
        name: "User IC - User initiated conversations",
        xAxis: dateAxis,
        yAxis: userAxis,
        valueYField: "user_initiated_conversations",
        valueXField: "conversation_start_date",
        stroke: am5.color(0X00BA34),
        fill: am5.color(0XFFFFFF),
      })
    );
    const totalSalesToolTip = userSeries.set("tooltip", am5.Tooltip.new(root, { pointerOrientation: "left" }));
    totalSalesToolTip.label.adapters.add("text", function(text, target) {
      text = '';
      chart.series.each(function (series, index) {
        text +=   series.get("name").slice(0, series.get("name").indexOf("-")) +'\n'+ '[/] [bold]{' + series.get("valueYField") + '} [/][font-size: 10px !important;color: #0E0E0E;font-family:Montserrat;font-style: normal;font-weight: 400;line-height: 9px;]';
        if(chart.series.length != index+1) text += '\n'+'------------'+'\n'
      });
      return text;
    });
    totalSalesToolTip.get("background").setAll({
      fill: am5.color(0xFFFFFF),
      stroke: am5.color(0XECECEC),
      shadowColor: am5.color(0XECECEC),
      shadowOffsetX: 10,
      shadowOffsetY: 10,
      shadowBlur: 5
    });
    userSeries.bullets.push(function(root) {
      return am5.Bullet.new(root, {
        sprite: am5.Circle.new(root, {
          strokeWidth: 2,
          radius: 7,
          stroke: root.interfaceColors.get("background"),
          fill: am5.color(0x00BA34),
        })
      });
    });

    const businessSeries = chart.series.push(
      am5xy.LineSeries.new(root, {
        name: "Business IC - Business initiated conversations",
        xAxis: dateAxis,
        yAxis: userAxis,
        valueYField: "business_initiated_conversations",
        valueXField: "conversation_start_date",
        stroke: am5.color(0X386AF6),
        fill: am5.color(0XFFFFFF),
      })
    );
    // const avgToolTip = businessSeries.set("tooltip", am5.Tooltip.new(root, {}));
    // avgToolTip.label.set("text", "Business IC: \{valueY}");
    // avgToolTip.get("background").setAll({
    //   fill: am5.color(0xFFFFFF),
    //   stroke: am5.color(0XECECEC),
    //   shadowColor: am5.color(0XECECEC),
    //   shadowOffsetX: 10,
    //   shadowOffsetY: 10,
    //   shadowBlur: 5,
    // });
    businessSeries.strokes.template.setAll({
      strokeWidth: 2
    });
    businessSeries.bullets.push(function(root) {
      return am5.Bullet.new(root, {
        sprite: am5.Circle.new(root, {
          strokeWidth: 2,
          radius: 7,
          stroke: root.interfaceColors.get("background"),
          shadowColor: am5.color(0XFFFFFF),
          fill: am5.color(0X386AF6),
        })
      });
    });


    // Add legend
    // const legend = chart.children.push(am5.Legend.new(root, {
    //   x: am5.percent(10),
    //   position: 'relative',
    //   disabled: true,
    //   centerX: am5.percent(10),
    //   layout: am5.GridLayout.new(root, {
    //     maxColumns: 3,
    //     fixedWidthGrid: true
    //   })
    // }));
    // legend.data.setAll(chart.series.values);


    // Add cursor
    const cursor = chart.set("cursor", am5xy.XYCursor.new(root, {
      behavior: "zoomX",
      xAxis: dateAxis,
    }));
    cursor.lineY.setAll({
      stroke: am5.color('#000'),
      strokeWidth: 2,
      strokeOpacity: 0,
      fillOpacity: 0.1
    });

    this.dateAxis = dateAxis;
    // this.orderCountSeries = orderCountSeries;
    this.userSeries = userSeries;
    this.businessSeries = businessSeries;
    this.totalsChart = chart;
  }
}
